/**
 * Check if the given string matches the format of a DT-generated gift voucher ref.
 *
 * From AbstractRefGenerator in the backend, the following characters are possible.
 * 0-9 and A-Z but with these removed:
 * 1 + 0, I + O, which can be commonly confused
 * E which can cause problems when interpreted as scientific notation
 * A, U which can spell naughty words
 *
 * All gift voucher refs begin with V and are 16 characters long.
 *
 * @param {string} ref
 * @return {boolean}
 */
const refMatchesDtVoucherCodePattern = (ref) => {
    return !!(ref || '')
        .replace(/[\s-]/g, '')
        .match(/^V[2-9BCDFGHJKMNPQRSTVWXYZ]{15}$/i); // Length 15 because the V is not included.
};

module.exports = {
    refMatchesDtVoucherCodePattern,
};
